<template>
   <div>
     <div v-for="(dates, date) in requestedAppointments" :key="date">
       <details class="flex flex-col border-solid border-b border-grey-lightest details">
         <summary class="flex flex-row text-grey-extradark h-12 px-4 cursor-pointer summary">
           <div class="text-xs self-center mx-5 pointer-none">{{date ? date : '-'}}</div>
           <div class="flex flex-row mx-auto items-baseline self-center"> 
             <div class="-ml-24 text-xs ">APPOINTMENTS</div>
             <div class="text-xs font-semibold">&nbsp;&nbsp;{{Object.keys(dates).reduce((total, date) => total += dates[date].length, 0)}}</div>
           </div>
         </summary>
         <div v-for="(timeRanges, range) in dates" :key="range">
           <details class="flex flex-col border-solid border-b border-grey-lightest sub-details">
             <summary class="flex flex-row h-10 px-4 text-grey-darker cursor-pointer bg-grey-lightest sub-summary">
               <div class="text-xs self-center mx-5 pointer-none">{{range}}</div>
               <div class="flex flex-row items-baseline self-center"> 
                 <div class="ml-24 text-xs ">APPOINTMENTS</div>
                 <div class="text-xs font-semibold">&nbsp;&nbsp;{{timeRanges.length}}</div>
               </div>
               <div class="flex flex-row items-baseline self-center"> 
                 <div class="ml-24 text-xs ">Self Assigned</div>
                 <div class="text-xs font-semibold">&nbsp;({{getSelfAssignedCount(timeRanges).selfAssigned}})</div>
               </div>
               <div class="flex flex-row items-baseline self-center"> 
                 <div class="ml-24 text-xs ">Un Assigned</div>
                 <div class="text-xs font-semibold">&nbsp;({{getSelfAssignedCount(timeRanges).unAssigned}})</div>
               </div>
             </summary>
             <div class="flex flex-col"> 
               <!--START-Header-->
               <div class="grid_container bg-grey-extralight text-grey-dark">
                 <div class="item_header">Apt. Time</div>
                 <div class="item_header">Patient ID</div>
                 <div class="item_header">Patient Email</div>
                 <div class="item_header">Patient Name</div>
                 <div class="item_header">Mobile Number</div>
                 <div class="item_header">Program Name</div>
                 <div class="item_header">Status</div>
                 <div class="item_header">Remarks</div>
                 <div class="item_header">Actions</div>
               </div>
               <!--END-Header-->
 
               <div class="grid_container" v-for="(appt) in timeRanges" :key="appt.id">
                 <div class="item">{{appt.date_of_appointment ? appt.date_of_appointment : '-'}}</div>
                 <div class="item">{{appt.ek_id}}</div>
                 <div class="item">{{appt.email}}</div>
                 <div class="item">{{appt.name}}</div>
                 <div class="item">{{appt.mobile_number}}</div>
                 <div class="item">{{appt.program ? appt.program : 'NA'}}</div>
                 <div class="item">{{ appt.status }}</div>
                 <div class="item flex flex-row">
                   <!--remark preview-->
                   <i id="remark_preview_icon" class="fas fa-eye text-blue cursor-pointer">
                     <div id="remark_preview" class="relative">
                       <!--Remark tip triangle-->
                       <div class="absolute -mt-1">
                         <i class="fas fa-caret-up text-xl text-grey-lighter"></i>
                       </div>
                       <!--Remark box-->
                       <div class="absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lighter px-3 py-2 rounded overflow-y-auto" style="width: 300px;">
                         <!--Remark text-->   
                         <div v-if="!appt.comments" id="remark_preview_text" class="text-black text-xs font-sans leading-tight" style="word-break: break-all;">No Remarks Added</div>
                         <div v-else id="remark_preview_text" class="text-black text-xs font-sans leading-tight" style="word-break: break-all;">{{appt.comments}}</div>
                       </div>
                     </div>
                   </i>
                   <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                   <!--remark edit-->
                   <i v-bind:id="`remark_edit_icon${appt.id}`" class="far fa-edit text-blue cursor-pointer" @click="showRemarkEdit(appt.id)">
                     <div v-bind:id="`remark_edit${appt.id}`" class="relative" style="display: none">
                       <!--Remark tip triangle-->
                       <div class="absolute -mt-1">
                         <i class="fas fa-caret-up text-xl text-grey-lighter"></i>
                       </div>
                       <!--Remark box-->
                       <div class="absolute flex flex-col flex-shrink pin-r mt-2 -mr-10 bg-grey-lighter px-3 py-3 rounded overflow-y-auto" style="width: 300px;">
                         <!--Remark input box--> 
                         <input type="text" v-bind:id="`remark_input_${appt.id}`" name="remark_input" placeholder="Enter your remark here" v-model="appt.comments" class="rounded-sm text-black text-xs font-sans leading-tight outline-none py-2 px-2" style="word-break: break-all; width: auto;">
                         <div class="flex flex-row justify-end mt-3 font-sans text-xs">
                           <div class="mx-3 cursor-pointer" @click="remarkChanged(appt.id)">Save</div>
                           <div class="cursor-pointer" @click="hideRemarkEdit(appt.id)">Cancel</div>
                         </div> 
                       </div>
                     </div>
                   </i>
                 </div>
                 <div class="item flex justify-start" >
                   <p v-if="appt.status === 'scheduled' && appt.doctor.id !== current_doctor_id" class="text-center text-green font-semibold">{{ appt.doctor.name }} has self assigned</p>
                   <button v-if="appt.status !== 'scheduled' || appt.doctor.id === current_doctor_id" @click="selfAssign(appt.id, appt.date_of_appointment, appt.doctor.id, appt.status)" v-bind:class="[(appt.status === 'scheduled' && appt.doctor.id === current_doctor_id) ? 'bg-red' : 'bg-blue']" class="flex-no-shrink hover:shadow-md flex-no-grow px-3 text-white rounded-sm j text-center py-1 items-center">
                     {{ (appt.status === 'scheduled' && appt.doctor.id === current_doctor_id) ? 'Unassign' : 'Self Assign'}}
                  </button>
                     <!--END Upload Dialog box-->    
                 </div>
               </div>
             </div>
           </details>
         </div>
       </details>
     </div>
   </div>
 </template>
 <script src="vue-datetime.js"></script>
 <script>
   import { Datetime } from 'vue-datetime'
   import appointments from '../../api/appointments'
   import store from '../../store'
   export default {
     data () {
       return {
         interval_id: '',
         current_doctor_id: store.state.configuration.id,
         requestedAppointments: {}
       }
     },
     components: {
       datetime: Datetime
     },
     mounted () {
       this.getAppointments(false)
       this.interval_id = setInterval(() => {
         this.getAppointments()
       }, 10000)
     },
     beforeDestroy () {
       clearInterval(this.interval_id)
     },
     methods: {
       statusChanged: function (status, id) {
         this.$emit('updateStatus', {status: status, id: id})
       },
       getSelfAssignedCount: function (appointments) {
         return appointments.reduce((count, appt) => {
           if (appt.status === 'scheduled' && appt.doctor.id === this.current_doctor_id) count.selfAssigned = count.selfAssigned + 1
           if (appt.status === 'requested') count.unAssigned = count.unAssigned + 1
           return count
         }, {selfAssigned: 0, unAssigned: 0})
       },
       getAppointments: function (showLoader = true) {
         appointments.fetch('requested', true).then(response => {
           if (response.status === 200) {
             this.requestedAppointments = response.body.appointment_requests
           } else { }
         }, response => {
           this.$toast.open({message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false})
         })
       },
       remarkChanged: function (id) {
         const remarkInput = document.getElementById('remark_input_' + id)
         appointments.updateRemark({id, doctor_comments: remarkInput.value}).then(response => {
           if (response.status === 200) {
             this.hideRemarkEdit(id)
             this.getAppointments(false)
           }
         })
       },
       selfAssign: function (id, apptTime, doctorId, status) {
         const apptTimeDifference = new Date(apptTime.replace('|', '')).getTime() - new Date().getTime()
         const isUnassign = doctorId === this.current_doctor_id && status === 'scheduled'
         const type = isUnassign ? 'unassign' : 'assign'
         if (apptTimeDifference < (5 * 60 * 1000) && type !== 'assign') {
           this.$toast.open({message: 'You cannot deassign this appointment now.', type: 'error'})
           return
         }
         appointments.selfAssign({id, type}).then(response => {
           if (response.status === 200) {
             this.getAppointments(false)
             this.$toast.open({message: isUnassign ? 'Unassigned' : 'Assigned' + ' successfully', type: 'success', position: 'bottom-right', queue: false})
           } else this.$toast.open({message: 'Error. Could not ' + isUnassign ? 'Unassign' : 'assign' + ' appointment request', type: 'error', position: 'bottom-right', queue: false})
         }).catch(() => {
           this.$toast.open({message: 'Something went wrong', type: 'error', position: 'bottom-right', queue: false})
         })
       },
       showRemarkEdit: function (id) {
         document.getElementById('remark_edit' + id).style.display = 'block'
       },
       hideRemarkEdit: function (id) {
         document.getElementById('remark_edit' + id).style.display = 'none'
         event.stopPropagation()
       }
     }
   }
 </script>
 <style scoped>
 .summary{
	background-color: #D6D8DC;
 }
 summary::-webkit-details-marker{
   display: none;
 }
 summary:focus {
   outline: none;
 }
 summary::before{
   border-radius: 5px;
   content:"+";
   color: #4a4a4a;
   margin: 13px 0px 0px -05px;
   padding: 0;
   text-align: center;
   width: 20px;
   height: 20px;
   position: relative;
   cursor: pointer;
   
 }
 .details[open] .summary::before{
     content: "-";
 }
 .sub-summary::before{
   content: "+";
 }
 .sub-details[open] .sub-summary::before{
   content: "-";
 }
 .grid_container{
   display: grid;
   border-collapse: collapse;
   padding: 10px;
   grid-template-columns: 
     minmax(140px, auto)      /* Appoitment Date & Time */
     minmax(100px, auto)       /* Patient ID */
     minmax(140px, auto)       /* Patient Email */
     minmax(140px, 200px)      /* Patient Name */
     minmax(80px, auto)        /* Mobile Number */
     minmax(160px, auto )       /* Program Name */
     minmax(100px, auto)      /* Status */
     minmax(70px, auto)        /* Remarks */
     minmax(100px, auto);     /* Actions */
 }
 .item_header{
     padding: 0px;
     margin: 0px 1px 0px 1px;
     text-align: left;
     font-size: 12px;
 }
 .item{
   padding: 0px;
   margin: 0px 1px 0px 1px;
   text-align: left;
   font-size: 12px;
   color: #4a4a4a;
   max-width: 120px;
   word-wrap: break-word;
 }
 select {
   background-color: white;
   display: inline-block;
   font: inherit;
   margin: 0; 
   outline: none;
   color: inherit;
 }
 #remark_preview_icon > div{
   display: none;
 }
 #remark_preview_icon:hover > div{
   display: block;
 }
 </style>
 


// WEBPACK FOOTER //
// src/components/Appointments/RequestedAppointmentTable.vue